import { ApiCallStatus } from '../../../services/api-call-status';
import { RootState } from '../../../store';
import { AvailabilityFilter } from './slice';

export const selectSchedulerFilter = (state: RootState): AvailabilityFilter => state.schedulerFilter.filter;
export const isHydratedSchedulerFilterLoading = (state: RootState): ApiCallStatus =>
    state.schedulerFilter.initialParams.status;
export const isFilterComplete = (state: RootState): boolean => state.schedulerFilter.filterSelectionComplete;
